import { memo, useCallback } from 'react';

import { Button } from '@air/primitive-button';

export type WorkspaceAgentStepperControlProps = {
  max: number;
  min: number;
  onChange: (value: number) => void;
  step: number;
  value: number;
};

export const WorkspaceAgentStepperControl = memo(
  ({ max, min, onChange, step, value }: WorkspaceAgentStepperControlProps) => {
    const handleDecrease = useCallback(() => {
      const next = value - step;

      if (next >= min) {
        onChange(next);
      }
    }, [min, onChange, step, value]);
    const handleIncrease = useCallback(() => {
      const next = value + step;

      if (next <= max) {
        onChange(next);
      }
    }, [max, onChange, step, value]);

    return (
      <div className="flex items-center gap-2">
        <Button
          appearance="outline"
          color="gray"
          data-testid="WORKSPACE_AGENT_STEPPER_DECREASE"
          disabled={value - step < min}
          onClick={handleDecrease}
          size="small"
        >
          −
        </Button>
        <span className="min-w-8 text-center text-14 text-gray-12">{value}</span>
        <Button
          appearance="outline"
          color="gray"
          data-testid="WORKSPACE_AGENT_STEPPER_INCREASE"
          disabled={value + step > max}
          onClick={handleIncrease}
          size="small"
        >
          +
        </Button>
      </div>
    );
  },
);

WorkspaceAgentStepperControl.displayName = 'WorkspaceAgentStepperControl';
